import { render, staticRenderFns } from "./SupplierOrder.vue?vue&type=template&id=fdc617ce"
import script from "./SupplierOrder.vue?vue&type=script&lang=js"
export * from "./SupplierOrder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports